module.exports = __webpack_public_path__ + "img/86.2db38bc5.svg";